
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/contact",
      function () {
        return require("private-next-pages/company/contact.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/contact"])
      });
    }
  